import React from 'react';

interface Props {
  children: React.ReactChild;
}

const InputError = ({ children }: Props) => <span className="position--relative">{children}</span>;

export default InputError;
